import cx from "classnames";

export function FormHeading({ title, subtitle, className }) {
    return (
        <div className={`mx-auto max-w-3xl text-center ${className}`}>
            {title && (
                <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    {title}
                </h2>
            )}

            {subtitle && (
                <p className="mx-auto mt-5 text-base italic text-gray-600">{subtitle}</p>
            )}
        </div>
    );
}

export function A({className, href = null, children, ...props}) {
    if(href){
        return <a href={href} {...props} className={cx("text-orange-500 hover:text-orange-700", className)}>{children}</a>
    }
    return <button {...props} className={cx("text-orange-500 hover:text-orange-700", className)}>{children}</button>
}